(function () {

  function initReviewCarousels(root) {

    var scope = root || document;

    var viewports = scope.querySelectorAll('[data-bd-rev]');

    viewports.forEach(function (viewport) {

      if (viewport.dataset.bdRevInitialized === 'true') {
        return;
      }

      viewport.dataset.bdRevInitialized = 'true';


      var track = viewport.querySelector(
        '[data-bd-rev-track]'
      );

      if (!track) return;


      var section = viewport.closest(
        '[data-bd-rev-section]'
      );

      var dotsWrap = section
        ? section.querySelector('[data-bd-rev-dots]')
        : null;


      var originalSlides = Array.prototype.slice.call(
        track.querySelectorAll(
          '[data-bd-rev-original]'
        )
      );


      if (!originalSlides.length) {
        return;
      }


      /* =====================================================
         SETTINGS
         ===================================================== */

      var reduceMotion =
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;


      var speedSetting =
        parseFloat(
          viewport.getAttribute('data-speed')
        ) || 4;


      /*
        Keep movement smooth and not too aggressive.
      */

      var pxPerFrame =
        reduceMotion
          ? 0
          : speedSetting * 0.15;


      /* =====================================================
         STATE
         ===================================================== */

      var posX = 0;

      var isPaused = false;

      var isDragging = false;

      var touchActive = false;

      var hasDragged = false;

      var dragStartX = 0;

      var dragStartPos = 0;

      var snapPoints = [];

      var activeDotIndex = -1;

      var animationFrame = null;


      /* =====================================================
         GET WIDTH OF ONE COMPLETE SET
         ===================================================== */

      function singleSetWidth() {

        if (!originalSlides.length) {
          return 0;
        }

        var firstSlide =
          originalSlides[0];

        var lastSlide =
          originalSlides[
            originalSlides.length - 1
          ];


        var firstLeft =
          firstSlide.offsetLeft;

        var lastRight =
          lastSlide.offsetLeft +
          lastSlide.offsetWidth;


        /*
          Include the gap after the last original slide.
        */

        var gap = 20;

        return (
          lastRight -
          firstLeft +
          gap
        );
      }


      /* =====================================================
         MEASURE SNAP POSITIONS
         ===================================================== */

      function measureSnapPoints() {

        snapPoints =
          originalSlides.map(
            function (slide) {

              return slide.offsetLeft;
            }
          );
      }


      /* =====================================================
         BUILD DOTS
         ===================================================== */

      function buildDots() {

        if (!dotsWrap) {
          return;
        }


        dotsWrap.innerHTML = '';


        originalSlides.forEach(
          function (slide, i) {

            var dot =
              document.createElement(
                'button'
              );


            dot.type = 'button';

            dot.className =
              'bd-dot';


            dot.setAttribute(
              'aria-label',
              'Go to item ' +
              (i + 1)
            );


            dot.addEventListener(
              'click',
              function () {

                var setWidth =
                  singleSetWidth();


                if (!setWidth) {
                  return;
                }


                posX =
                  -(
                    setWidth +
                    snapPoints[i]
                  );


                render();
              }
            );


            dotsWrap.appendChild(dot);
          }
        );
      }


      /* =====================================================
         UPDATE ACTIVE DOT
         ===================================================== */

      function updateActiveDot() {

        if (
          !dotsWrap ||
          !snapPoints.length
        ) {
          return;
        }


        var setWidth =
          singleSetWidth();


        if (setWidth <= 0) {
          return;
        }


        var visiblePos =
          ((-posX % setWidth) +
            setWidth) %
          setWidth;


        var closest = 0;

        var closestDist =
          Infinity;


        snapPoints.forEach(
          function (sp, i) {

            var dist =
              Math.abs(
                sp -
                visiblePos
              );


            /*
              Handle circular distance
              around the infinite loop.
            */

            dist =
              Math.min(
                dist,
                Math.abs(
                  setWidth -
                  dist
                )
              );


            if (
              dist <
              closestDist
            ) {

              closestDist =
                dist;

              closest = i;
            }

          }
        );


        if (
          closest !==
          activeDotIndex
        ) {

          activeDotIndex =
            closest;


          var dots =
            dotsWrap.querySelectorAll(
              '.bd-dot'
            );


          dots.forEach(
            function (dot, i) {

              dot.classList.toggle(
                'is-active',
                i ===
                activeDotIndex
              );

            }
          );

        }

      }


      /* =====================================================
         INFINITE WRAP
         ===================================================== */

      function wrap() {

        var setWidth =
          singleSetWidth();


        if (setWidth <= 0) {
          return;
        }


        if (
          posX <=
          -setWidth
        ) {

          posX +=
            setWidth;

        }


        if (
          posX >
          0
        ) {

          posX -=
            setWidth;

        }

      }


      /* =====================================================
         RENDER
         ===================================================== */

      function render() {

        track.style.transform =
          'translate3d(' +
          posX +
          'px, 0, 0)';


        updateActiveDot();

      }


      /* =====================================================
         AUTO SCROLL
         ===================================================== */

      function tick() {

        if (
          !isDragging &&
          !touchActive &&
          !isPaused
        ) {

          posX -=
            pxPerFrame;

        }


        wrap();

        render();


        animationFrame =
          requestAnimationFrame(
            tick
          );

      }


      /* =====================================================
         INITIAL MEASUREMENT
         ===================================================== */

      measureSnapPoints();

      buildDots();


      requestAnimationFrame(
        function () {

          var setWidth =
            singleSetWidth();


          if (setWidth > 0) {

            /*
              Start from the middle set.
            */

            posX =
              -setWidth;

          }


          render();


          animationFrame =
            requestAnimationFrame(
              tick
            );

        }
      );


      /* =====================================================
         RESIZE
         ===================================================== */

      var resizeTimer;


      window.addEventListener(
        'resize',
        function () {

          clearTimeout(
            resizeTimer
          );


          resizeTimer =
            setTimeout(
              function () {

                measureSnapPoints();

                render();

              },
              120
            );

        }
      );


      /* =====================================================
         HOVER PAUSE
         ===================================================== */

      viewport.addEventListener(
        'mouseenter',
        function () {

          isPaused = true;

        }
      );


      viewport.addEventListener(
        'mouseleave',
        function () {

          isPaused = false;

        }
      );


      /* =====================================================
         MOUSE DRAG
         ===================================================== */

      viewport.addEventListener(
        'mousedown',
        function (e) {

          /*
            Only left mouse button.
          */

          if (
            e.button !== 0
          ) {
            return;
          }


          isDragging = true;

          hasDragged = false;

          dragStartX =
            e.clientX;

          dragStartPos =
            posX;


          viewport.classList.add(
            'is-dragging'
          );


          e.preventDefault();

        }
      );


      function mouseMove(e) {

        if (!isDragging) {
          return;
        }


        var delta =
          e.clientX -
          dragStartX;


        if (
          Math.abs(delta) >
          3
        ) {

          hasDragged = true;

        }


        posX =
          dragStartPos +
          delta;


        wrap();

        render();

      }


      function mouseUp() {

        if (!isDragging) {
          return;
        }


        isDragging = false;


        viewport.classList.remove(
          'is-dragging'
        );

      }


      window.addEventListener(
        'mousemove',
        mouseMove
      );


      window.addEventListener(
        'mouseup',
        mouseUp
      );


      /* =====================================================
         PREVENT CLICK AFTER DRAG
         ===================================================== */

      viewport.addEventListener(
        'click',
        function (e) {

          if (hasDragged) {

            e.preventDefault();

            e.stopPropagation();

            hasDragged = false;

          }

        },
        true
      );


      /* =====================================================
         TOUCH START
         ===================================================== */

      viewport.addEventListener(
        'touchstart',
        function (e) {

          if (
            !e.touches ||
            !e.touches.length
          ) {
            return;
          }


          touchActive = true;

          hasDragged = false;

          dragStartX =
            e.touches[0].clientX;

          dragStartPos =
            posX;

        },
        {
          passive: true
        }
      );


      /* =====================================================
         TOUCH MOVE
         ===================================================== */

      viewport.addEventListener(
        'touchmove',
        function (e) {

          if (
            !touchActive ||
            !e.touches ||
            !e.touches.length
          ) {
            return;
          }


          var delta =
            e.touches[0].clientX -
            dragStartX;


          if (
            Math.abs(delta) >
            5
          ) {

            hasDragged = true;

          }


          posX =
            dragStartPos +
            delta;


          wrap();

          render();

        },
        {
          passive: true
        }
      );


      /* =====================================================
         TOUCH END
         ===================================================== */

      viewport.addEventListener(
        'touchend',
        function () {

          touchActive = false;

        }
      );


      viewport.addEventListener(
        'touchcancel',
        function () {

          touchActive = false;

        }
      );


      /* =====================================================
         TWO-FINGER / TRACKPAD HORIZONTAL SCROLL
         ===================================================== */

      viewport.addEventListener(
        'wheel',
        function (e) {

          if (
            Math.abs(e.deltaX) <=
            Math.abs(e.deltaY)
          ) {
            return;
          }


          e.preventDefault();


          posX -=
            e.deltaX;


          wrap();

          render();

        },
        {
          passive: false
        }
      );

    });

  }


  /* =========================================================
     INITIAL LOAD
     ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initReviewCarousels(
          document
        );

      }
    );

  } else {

    initReviewCarousels(
      document
    );

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initReviewCarousels(
        event.target
      );

    }
  );


  document.addEventListener(
    'shopify:section:reorder',
    function () {

      initReviewCarousels(
        document
      );

    }
  );


  document.addEventListener(
    'shopify:section:select',
    function (event) {

      initReviewCarousels(
        event.target
      );

    }
  );

})();